import { useTranslation } from 'react-i18next';

export function LoginPage({ configured }: { configured: boolean }) {
  const { t } = useTranslation();
  return (
    <main className="login-page">
      <div className="login-card">
        <div className="wordmark wordmark--dark">novatize</div>
        <p className="eyebrow">{t('login.eyebrow')}</p>
        <h1>{t('login.title')}</h1>
        <p>{t('login.description')}</p>
        {configured ? (
          <a className="primary-action" href="/api/v1/auth/google">
            {t('login.continue')}
          </a>
        ) : (
          <div className="error-panel" role="alert">
            {t('login.oauthMissing')}
          </div>
        )}
      </div>
    </main>
  );
}
